<div class="flex flex-column" *ngIf="eventPricing && initialised">
  <ng-container *ngIf="!hasNoAvailablePrices">
    <ng-container *ngFor="let ticketType of eventPricing.ticketTypes">
      <table class="ticket-select-table" *ngIf="isTicketTypeAvailable(ticketType)">
        <tr class="price-type-default price-header-row">
          <td class="max-width body-3 text-grey">{{ getRemainingQuantity(ticketType) | quantityInPcs }}</td>
          <td class="price-type-price">{{ ticketType.price | price }}</td>
        </tr>
        <tr class="price-type-default">
          <td class="price-type-name">{{ ticketType.name | translateValue }}</td>
          <td>
            <app-add-remove [alignRight]="true"
                            [max]="getMaxTickets(ticketType)"
                            [count]="ticketTypeCountMap[ticketType.uuid] || 0"
                            [withHints]="cartService.isSelfService"
                            (countChange)="changeTicketCount(ticketType.uuid, $event)"
                            (add)="changeTicketTypeCount(ticketType.uuid)"
                            (remove)="changeTicketTypeCount(ticketType.uuid, true)"></app-add-remove>
          </td>
        </tr>
      </table>
    </ng-container>
    <div class="add-to-cart-button" *ngIf="!routeService.isWindow && eventPricing.ticketTypes?.length">
      <div class="flex flex-wrap flex-end">
        <button mat-stroked-button color="primary" class="desktop" *ngIf="authService.checkSalespointProperty('popup_box_office')" (click)="openCustomerScreen.emit()">
          {{ 'general.api_sales_customer_screen' | translate }}
        </button>
        <button mat-flat-button color="primary" [disabled]="!hasAnyTicketsSelected || areAnyInputValuesInvalid" (click)="addToCart()">
          {{ 'general.api_cart_add' | translate }}
        </button>
      </div>

    </div>
  </ng-container>
  <app-info-message *ngIf="hasNoAvailablePrices" [message]="'general.api_sales_no_ticket_types'" [icon]="'alert'" [large]="true"></app-info-message>
</div>
<app-loader [loading]="ticketTypeService.typesLoading" [overlay]="true"></app-loader>
